import config from '../../../api/config.json';

export default [
  {
    id: 'date',
    text: 'Data',
    title: 'Data do registro',
    checked: true
  },
  {
    id: '_id',
    text: 'Identificador',
    title: 'Identificador do objeto (grupo, operador, etc)',
    checked: true
  },
  {
    id: 'callId',
    text: 'Id Ligação',
    title: 'Identificador desta ligação/evento no banco de dados',
    checked: true
  },
  {
    id: 'way',
    text: 'Sentido',
    title: 'Sentido da ligação',
    checked: true
  },
  {
    id: 'client',
    text: 'Cliente',
    title: 'Cliente da ligação',
    checked: true
  },
  {
    id: 'department',
    text: 'Departamento',
    title: 'Departamento',
    checked: true
  },
  {
    id: 'from',
    text: 'Número de',
    title: 'Número de onde a ligação foi enviada para este destino',
    checked: true
  },
  {
    id: 'fromAgent',
    text: 'Do operador',
    title: 'Operador/Grupo que encaminhou a ligação',
    checked: true
  },
  {
    id: 'to',
    text: 'Para',
    title: 'Ramal/Grupo para o qual a ligação foi encaminhada',
    checked: true
  },
  {
    id: 'toAgent',
    text: 'Para operador',
    title: 'Operador/Grupo para o qual a ligação foi encaminhada',
    checked: true
  },
  {
    id: 'file',
    text: 'Gravação',
    title: 'Gravação da ligação',
    checked: true,
    render: data => {
      const id = data.split('/').slice(-1)[0];
      const token = localStorage.getItem('token');
      const html = `
        <div>
          <audio id="${id}" style="display: none;" controls preload="none">
          <source src="${config.protocol}://${config.ipServerGW}:${config.portServerGW}/api/record_ports/audio?file=${data}&token=${token}" type="audio/ogg">
          </audio>
          <div class="audio-container">
            <span audio="${id}" class="fa fa-play audio-play-pause"></span>
            <div class="audio-timer-container">
              <span>&nbsp;</span>
              <span id="tm-${id}">00:00</span>
              <span>&nbsp;/&nbsp;</span>
              <span id="drt-${id}">00:00</span>
              <span>&nbsp;</span>
              <div class="audio-slidecontainer">
                <input id="rng-${id}" value="0" type="range" disabled class="audio-slider">
              </div>
              <span>&nbsp;&nbsp;&nbsp;</span>
            </div>
            <span id="dwn-${id}" class="fa fa-download audio-download" url-audio="${config.protocol}://${config.ipServerGW}:${config.portServerGW}/api/record_ports/audio_download?file=${data}&token=${token}"></span>
          </div>
        <div>`;
      return html;
    }
  }
];
